import {
  GET_LASTTRANSACTION_REQUESTED,
  GET_LASTTRANSACTION_SUCCESS,
  GET_LASTTRANSACTION_FAILED,
  GET_LASTTRANSACTIONBATCH_REQUESTED,
  GET_LASTTRANSACTIONBATCH_SUCCESS,
  GET_LASTTRANSACTIONBATCH_FAILED,
  EDIT_TRANSACTION_REQUESTED,
  EDIT_TRANSACTION_SUCCESS,
  EDIT_TRANSACTION_FAILED,
  RESET_TRANSACTIONS
} from './actionTypes'

export const getLastTransaction = payload => ({
  type: GET_LASTTRANSACTION_REQUESTED,
  payload
})

export const getLastTransactionSuccess = payload => ({
  type: GET_LASTTRANSACTION_SUCCESS,
  payload
})

export const getLastTransactionFailed = payload => ({
  type: GET_LASTTRANSACTION_FAILED,
  payload
})


export const getLastTransactionBatch = payload => ({
  type: GET_LASTTRANSACTIONBATCH_REQUESTED,
  payload
})

export const getLastTransactionBatchSuccess = payload => ({
  type: GET_LASTTRANSACTIONBATCH_SUCCESS,
  payload
})

export const getLastTransactionBatchFailed = payload => ({
  type: GET_LASTTRANSACTIONBATCH_FAILED,
  payload
})

export const editTransaction = payload => ({
  type: EDIT_TRANSACTION_REQUESTED,
  payload
})

export const editTransactionSuccess = payload => ({
  type: EDIT_TRANSACTION_SUCCESS,
  payload
})

export const editTransactionFailed = payload => ({
  type: EDIT_TRANSACTION_FAILED,
  payload
})

export const resetTransaction = payload => ({
  type: RESET_TRANSACTIONS,
  payload
})
